import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { FormattedMessage, useIntl } from "react-intl";
import styled from "@emotion/styled";
import { useTeamDailyReport } from "hooks";
import { useParams } from "react-router";
import PageTitle from "components/PageTitle";
import { PageWrapper, Grid } from "components/Containers";
import { getCurrentUTCDate } from "utils";
import { ActivityPeriodSelector } from "components/ActivityLog";
import { DailyReportLayout } from "components/DailyReport";
import ScrollToTopButton from "components/ScrollToTopButton";

/**
 * DailyReport
 */
const DailyReport = () => {
  const { id } = useParams();
  const intl = useIntl();
  const [selectedDate, setSelectedDate] = useState(getCurrentUTCDate());
  const { data, loading, error } = useTeamDailyReport({ teamId: id, selectedDate });

  const handleChange = (_name, value) => setSelectedDate(value);

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Squads.DailyReport.Title" })}</title>
      </Helmet>
      <PageWrapper>
        <Grid>
          <Grid.col start={1} end={13}>
            <StyledPageTitle
              subtitle={<FormattedMessage id="Squads.DailyReport.Title" />}
              actionBar={<ActivityPeriodSelector value={selectedDate} onChange={handleChange} enableDateCycle />}
            />
          </Grid.col>
          <Grid.col start={1} end={13}>
            <DailyReportLayout data={data} loading={loading} error={error} />
          </Grid.col>
        </Grid>
      </PageWrapper>
      <ScrollToTopButton />
    </>
  );
};

const StyledPageTitle = styled(PageTitle)`
  .PageTitle-inner_container {
    align-items: anchor-center;
  }
`;

export default DailyReport;
